import * as React from 'react';
import { lazy, Suspense } from 'react';

import { IState } from '@redux';

import { IRouteConfigComponent } from '@interfaces';

const requireLazyRoute = async (
	moduleImport: () => Promise<unknown>,
	exportName: string,
	// eslint-disable-next-line @typescript-eslint/require-await
) => {
	return lazy(
		// eslint-disable-next-line @typescript-eslint/require-await
		async () => {
			const module = await moduleImport();
			const Module = module as Record<string, React.ComponentType<unknown>>;
			const Component = Module[exportName];

			return { default: Component };
		},
	);
};

export const lazyRoute = async (
	moduleImport: () => Promise<unknown>,
	exportName: string,
) => {
	const Component = await requireLazyRoute(moduleImport, exportName) as unknown as IRouteConfigComponent['component'];

	if (!Component) {
		return null;
	}

	const Enhanced = (
		props: Record<string, unknown>,
	) => {
		return (
			<Suspense fallback={null}>
				<Component {...props}/>
			</Suspense>
		);
	};

	Enhanced.displayName = `LazyRoute${exportName}`;
	Enhanced.getBreadcrumbs = async (state: IState) => {
		const module = await moduleImport();
		const Module = module as { getBreadcrumbs: IRouteConfigComponent['component']['getBreadcrumbs'] };

		if (Module.getBreadcrumbs) {
			return Module.getBreadcrumbs(state);
		} else {
			return [];
		}
	};

	return Enhanced as unknown as IRouteConfigComponent['component'];
};
